import '../../VendorStyles/Dashboard.css';
import { useState, useEffect } from 'react';
import img1 from '../../assets/TotalOrders.png';
import img2 from '../../assets/Totaldelivered.png';
import img4 from '../../assets/Totalrevenue.png';
import axiosVendorInstance from '../../axiosVendorInstance';

import {
    Menu,
    MenuItem,
    Button,
    Box,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    styled,
    Stack,
    Pagination,
    FormControl,
    InputLabel,
    Select,
} from '@mui/material';
import { FaCalendarAlt } from 'react-icons/fa';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import VendorSideMenuBar from './VendorLayouts/VendorSideMenuBar';
import VendorTopMenuBar from './VendorLayouts/VendorTopMenuBar';
import CommonButton from '../../Components/commonButton';
import Loader from '../../Components/Loader/Loader';
import axiosUserInstance from '../../axiosUserInstance';

function PaymentsList() {
    const [vendorName, setVendorName] = useState(null);
    const [orderData, setOrderData] = useState({
        totalOrders: 0,
        totalDelivered: 0,
        totalRevenue: 0,
    });
    const [tablePaymentData, setTablePaymentData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedOption, setSelectedOption] = useState('All');
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [showCustom, setShowCustom] = useState(false);
    const [customDate, setCustomDate] = useState({ start: null, end: null });
    const [pageNo, setPageNo] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [appliedDates, setAppliedDates] = useState({
        start: null,
        end: null,
    });

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setShowCustom(false);
    };

    const handleOptionClick = (option) => {
        if (option === 'Custom') {
            setSelectedOption('Custom');
            setShowCustom(true);
        } else {
            setSelectedOption(option);
            setShowCustom(false);
            handleClose();
        }
    };

    const fetchVendor = async () => {
        setLoading(true);
        const vendorResponse = await axiosVendorInstance.get('/vendors/account');
        setVendorName(vendorResponse?.data?.getVendorInfo[0]?.Name);
    };

    useEffect(() => {
        fetchVendor();
    }, [vendorName, pageNo]);

    const fetchPaymentData = async (
        startDate = appliedDates.start,
        endDate = appliedDates.end,
        status = selectedStatus
    ) => {
        try {
            const url =
        `/payment/getallpayments?statusText=${status}&vendorName=${vendorName}` + 
        (startDate && endDate
            ? `&startDate=${startDate}&endDate=${endDate}`
            : '') + `&page=${pageNo}&pageSize=10`;


            const response = await axiosUserInstance.get(url);
            if (response?.data && response?.data?.payments) {
                setTablePaymentData(response?.data?.payments);
                setTotalPages(response?.data?.pagination?.totalPages || 1);
            } else {
                setTablePaymentData([]);
                setTotalPages(1);
            }
            const totalOrdersCount = response?.data?.total_payments;
            const totalDeliveredCount = response?.data?.total_delivered;
            const totalEarnings = response?.data?.total_revenue;

            setOrderData({
                totalOrders: totalOrdersCount,
                totalDelivered: totalDeliveredCount,
                totalRevenue: totalEarnings,
            });
        } catch (err) {
            console.error('Error fetching order data:', err);
            setTablePaymentData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleApply = () => {
        let startDate, endDate;

        switch (selectedOption) {
        case 'Today':
            startDate = endDate = dayjs().format('YYYY-MM-DD');
            break;
        case 'Yesterday':
            startDate = endDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
            break;
        case 'Last 7 Days':
            startDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
            endDate = dayjs().format('YYYY-MM-DD');
            break;
        case 'Last 30 Days':
            startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
            endDate = dayjs().format('YYYY-MM-DD');
            break;
        case 'Custom':
            if (customDate?.start && customDate?.end) {
                startDate = dayjs(customDate?.start).format('YYYY-MM-DD');
                endDate = dayjs(customDate?.end).format('YYYY-MM-DD');
            } else {
                return;
            }
            break;
        case 'All':
            startDate = null;
            endDate = null;
            break;
        default:
            return;
        }

        setLoading(true);
        setAppliedDates({ start: startDate, end: endDate });
        setPageNo(1);
        fetchPaymentData(startDate, endDate, selectedStatus);
        handleClose();
    };

    const handleClear = () => {
        setLoading(true);
        setSelectedStatus('All');
        setSelectedOption('All');
        setCustomDate({ start: null, end: null });
        setShowCustom(false);
        setPageNo(1);
        setAppliedDates({ start: null, end: null });
        fetchPaymentData(null, null, 'All');
    };

    const handlePageChange = (event, value) => {
        setPageNo(value);
    };

    useEffect(() => {
        if (vendorName) {
            setLoading(true);
            fetchPaymentData();
        }
    }, [vendorName, pageNo]);

    const Orders = [
        { image: img1, count: orderData?.totalOrders ?? 0, type: 'Total Payments' },
        {
            image: img2,
            count: orderData?.totalDelivered ?? 0,
            type: 'Total Delivered',
        },
        {
            image: img4,
            count: `$${orderData?.totalRevenue ?? 0}`,
            type: 'Total Revenue',
        },
    ];

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        backgroundColor: '#e5e8f1',
        color: theme.palette.common.black,
        fontWeight: 'bold',
        fontFamily: 'var(--font-family)',
    }));

    const handleStatusChange = (event) => {
        const value = event.target.value;
        setSelectedStatus(value);
    };

    return (
        <>
            <VendorSideMenuBar />
            <VendorTopMenuBar />
            <div className='menu-main-container-vendor'>
                <div className='vendor-common-container'>
                    <div className='orders-page'>
                        <div className='dashboard-top1-container'>
                            <div className='order-filter-apply-container'>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                        {/* Dropdown Toggle Button */}
                                        <Button
                                            variant='outlined'
                                            startIcon={<FaCalendarAlt />}
                                            onClick={handleClick}
                                            className='date-dropdown-btn'
                                        >
                                            {selectedOption}
                                        </Button>

                                        {/* Dropdown Menu */}
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                        >
                                            {!showCustom ? (
                                                <>
                                                    {[
                                                        'All',
                                                        'Today',
                                                        'Yesterday',
                                                        'Last 7 Days',
                                                        'Last 30 Days',
                                                        'Custom',
                                                    ].map((option) => (
                                                        <MenuItem
                                                            key={option}
                                                            onClick={() => handleOptionClick(option)}
                                                        >
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                </>
                                            ) : (
                                                <Box sx={{ p: 2, width: { xs: '100%', sm: 350 } }}>
                                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                                        <DatePicker
                                                            label='Start Date'
                                                            value={customDate.start}
                                                            onChange={(date) =>
                                                                setCustomDate({ ...customDate, start: date })
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField {...params} fullWidth />
                                                            )}
                                                        />
                                                        <DatePicker
                                                            label='End Date'
                                                            value={customDate.end}
                                                            onChange={(date) =>
                                                                setCustomDate({ ...customDate, end: date })
                                                            }
                                                            minDate={customDate.start}
                                                            renderInput={(params) => (
                                                                <TextField {...params} fullWidth />
                                                            )}
                                                        />
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            mt: 2,
                                                        }}
                                                    >
                                                        <Button
                                                            className='custom-apply-btn'
                                                            variant='outlined'
                                                            onClick={handleClose}
                                                        >
                              Cancel
                                                        </Button>
                                                        <Button
                                                            className='custom-apply-btn'
                                                            variant='contained'
                                                            onClick={handleApply}
                                                        >
                              Apply
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Menu>
                                    </Box>
                                </LocalizationProvider>
                                <div className='filter-container'>
                                    <FormControl
                                        variant='outlined'
                                        slotProps={{ textField: { size: 'small' } }}
                                        sx={{
                                            minWidth: 200,
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#6D7383',
                                                },
                                            },
                                        }}
                                    >
                                        <>
                                            <InputLabel>Status</InputLabel>
                                            <Select
                                                value={selectedStatus}
                                                onChange={handleStatusChange}
                                                label='Status'
                                            >
                                                <MenuItem value='All'>All</MenuItem>
                                                <MenuItem value='Pending'>Pending</MenuItem>
                                                <MenuItem value='Completed'>Completed</MenuItem>
                                                <MenuItem value='In-Process'>In-Process</MenuItem>
                                                <MenuItem value='Rejected'>Rejected</MenuItem>
                                            </Select>
                                        </>
                                    </FormControl>
                                </div>
                                <CommonButton
                                    label={'Apply'}
                                    onClick={handleApply}
                                    style={{ height: '42px' }}
                                />
                                <CommonButton
                                    label={'Clear'}
                                    onClick={handleClear}
                                    style={{ height: '42px' }}
                                />
                            </div>
                        </div>
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className='dashboard-bottom-container'>
                                    {Orders?.map((payment, index) => (
                                        <div
                                            key={index}
                                            className='dashboard-bottom-single-container'
                                        >
                                            <div className='dashboard-order-img'>
                                                <img src={payment?.image}></img>
                                            </div>
                                            <div className='dashboard-order-count-and-type'>
                                                <h5 className='dashboard-order-count'>
                                                    {payment?.count}
                                                </h5>
                                                <h5 className='dashboard-order-type'>{payment?.type}</h5>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                {tablePaymentData && tablePaymentData?.length > 0 ? (
                                    <>
                                        <TableContainer
                                            component={Paper}
                                            sx={{
                                                borderRadius: 2,
                                                boxShadow: 3,
                                                maxHeight: 500,
                                                overflowX: 'auto',
                                                overflowY: 'auto',
                                                width: '100%',
                                            }}
                                        >
                                            <Table stickyHeader sx={{ minWidth: 900 }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell>Payment ID</StyledTableCell>
                                                        <StyledTableCell>Customer Name</StyledTableCell>
                                                        <StyledTableCell>Date</StyledTableCell>
                                                        <StyledTableCell>Amount</StyledTableCell>
                                                        <StyledTableCell>Status</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tablePaymentData?.map((payment) => (
                                                        <TableRow
                                                            key={payment?.id}
                                                            sx={{
                                                                '&:hover': {
                                                                    backgroundColor: '#f5f5f5',
                                                                    cursor: 'pointer',
                                                                },
                                                                transition: 'background-color 0.3s ease-in-out',
                                                            }}
                                                        >
                                                            <TableCell>{payment?.ID}</TableCell>
                                                            <TableCell>
                                                                {payment?.Usersdata
                                                                    ? `${payment?.Usersdata?.first_name} ${payment?.Usersdata?.last_name}`
                                                                    : 'N/A'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {new Date(payment?.Created_at)
                                                                    .getDate()
                                                                    .toString()
                                                                    .padStart(2, '0')}
                                -
                                                                {(new Date(payment?.Created_at).getMonth() + 1)
                                                                    .toString()
                                                                    .padStart(2, '0')}
                                -{new Date(payment?.Created_at).getFullYear()}{' '}
                                                                {new Date(
                                                                    payment?.Created_at
                                                                ).toLocaleTimeString()}
                                                            </TableCell>
                                                            <TableCell>
                                                                ${payment?.Total_amount != null 
                                                                    ? Number(payment?.Amount)?.toFixed(2) 
                                                                    : '0.00'}
                                                            </TableCell>
                                                            <TableCell>{payment?.status_text}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Stack spacing={2}>
                                            <Pagination
                                                sx={{
                                                    '& .MuiPagination-ul': {
                                                        color: '#333',
                                                        padding: 1,
                                                        borderRadius: 2,
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        listStyleType: 'none',
                                                    },
                                                }}
                                                count={totalPages}
                                                page={pageNo}
                                                onChange={handlePageChange}
                                                showFirstButton
                                                showLastButton
                                            />
                                        </Stack>
                                    </>
                                ) : (
                                    <>
                                        <div className='no-order11'>
                                            <p>No Payments Found</p>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default PaymentsList;
